module.exports = __webpack_public_path__ + "media/images/android-chrome-512x512-5e69db4bad3783c159970f1cdbbb1b4f.png";